import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { HelperServiceService } from '../../../../../utils/helper-service.service';
import { CommonModule } from '@angular/common';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { CourseService } from '../../../../../pages/courses/course.service';
import { ToasterService } from '../../../../../providers/toaster/toaster.service';
import { ConfomerService } from '../../../../../providers/confomer/confomer.service';
import { Store } from '@ngrx/store';
import { selectCourseId } from '../../../../../pages/courses/create-courses/store/course.selector';
import { take } from 'rxjs';
import { CourseHelperServiceService } from '../../../../../pages/courses/course-helper-service.service';

@Component({
  selector: 'app-badge-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CdkDragHandle],
  templateUrl: './badge-form.component.html',
  styleUrl: './badge-form.component.css'
})
export class BadgeFormComponent implements OnChanges {
  @Input() data: any
  @Input() index: any
  @Input() coursePublished: boolean = false

  courseId: any
  subjectId: any

  badgeData: any
  badgeForm!: FormGroup
  isPreview: boolean = true
  flag: number = 0

  isSubmitting = false;

  constructor(private helperService: HelperServiceService, private fb: FormBuilder,
    private courseApiService: CourseService, private toasterService: ToasterService,
    private conformDialog: ConfomerService, private store: Store, private couserHelper: CourseHelperServiceService
  ) {
    this.badgeForm = this.fb.group({
      id: [0],
      course_id: [0, Validators.required],
      structure_id: [0, Validators.required],
      badge_id: ['', Validators.required],
      activities_to_be_considered: [''],
    });
  }

  ngOnInit(): void {
    this.store.select(selectCourseId).pipe(take(1)).subscribe(value => {
      this.courseId = value
    })
    this.initializeComponentData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.initializeComponentData();
    }
  }

  private initializeComponentData() {
    this.isPreview = this.data?.badge?.isEditing ? false : true || false
    this.subjectId = this.data?.structure_id
    this.flag = this.data?.badge?.flag ?? 0
    this.badgeData = this.data?.badge
    this.patchValues(this.badgeData)
  }

  patchValues(data: any) {
    this.badgeForm.patchValue({
      id: data.id ?? 0,
      course_id: this.courseId ?? 0,
      structure_id: this.subjectId ?? 0,
      badge_id: data.badge_id ?? '',
      activities_to_be_considered: data.activities_to_be_considered ?? '',
    });
  }

  addBadgeStructure() {
    if (this.isSubmitting) return;
    if (this.badgeForm.invalid) {
      this.badgeForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }

    this.isSubmitting = true;
    const formData = this.createFormData(this.badgeForm.value);
    
    this.courseApiService.addBadgeNode(formData).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Badge Added', res.body.message);
          this.isPreview = true;
          this.patchValues(this.badgeForm.value);
          this.emitData('get_data');
        }
      } catch (error) {
        this.toasterService.setToaster('error', 'Badge failed to add', res?.body?.message);
      } finally {
        this.isSubmitting = false;
      }
    }, () => {
      this.isSubmitting = false;
    })
  }

  UpdateBadgeStructure() {
    if (this.isSubmitting) return;
    
    if (this.badgeForm.invalid) {
      this.badgeForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }

    this.isSubmitting = true;
    const formData = this.createFormData(this.badgeForm.value);
    formData.delete('id');
    let id = this.badgeForm.value.id
    this.courseApiService.updateBadgeNode(formData, id).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Badge Updated', res.body.message);
          this.isPreview = true;
          this.patchValues(this.badgeForm.value);
          this.emitData('get_data');
        }
      } catch (error) {
        this.toasterService.setToaster('error', 'Badge failed to update', res?.body?.message);
      } finally {
        this.isSubmitting = false;
      }
    }, () => {
      this.isSubmitting = false;
    })
  }

  async deleteBadgeStructure(id: any) {
    let confirm = await this.conformDialog.Open('Delete Badge', 'Are you sure you want to delete this badge?');
    if (confirm) {
      this.courseApiService.deleteBadgeNode(id).subscribe((res: any) => {
        try {
          if (res.body.status == "success") {
            this.toasterService.setToaster('success', 'Badge Deleted', res.body.message);
            this.emitData('get_data');
          }
        } catch (error) {
          this.toasterService.setToaster('error', 'Badge failed to delete', res.body.message);
        }
      })
    }
  }

  deleteBadgeStructureNew() {
    this.emitData('delete_badge_structure', this.index);
  }

  createFormData(data: any): FormData {
    const formData = new FormData();

    formData.append('course_id', data.course_id);
    formData.append('structure_id', data.structure_id);
    formData.append('badge_id', data.badge_id);
    formData.append('activities_to_be_considered', data.activities_to_be_considered);
    formData.append('is_active', '1');

    return formData;
  }

  closePreview() {
    this.isPreview = true
    this.patchValues(this.badgeData)
  }

  @Output() dataEvent = new EventEmitter<any>();

  emitData(action: string, index?: any) {
    let data = {
      action: action,
      index: index ?? null,
    }
    this.dataEvent.emit(data);
  }
}